import { unstable_createMuiStrictModeTheme as createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#6598FF',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#FFC106',
    },
  },
  typography: {
    body1: {
      fontSize: '14pt',
    },
    body2: {
      fontSize: '1.15rem',
      fontWeight: 600,
    },
  },
});

export default theme;
